import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { TermsService } from './terms.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.css'],
  providers: [TermsService]
})
export class TermsComponent implements OnInit {
  print = 'Cargando..';
  @ViewChild('dataR') dataR: ElementRef;
  constructor(public termsService: TermsService) { }

  ngOnInit() {
    this.terms();
  }

  terms() {
    this.termsService.terms().subscribe(resp => {
      this.dataR.nativeElement.innerHTML = resp.Contract_Text;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/terms/terms.component.ts